import { WatchList } from '../../../../models/WatchList';

export const ISSUERS_LIMIT_PER_WATCHLIST = 1000;
const ISSUERS_LIMIT_PER_USER = 3000;

export const WATCHLIST_LIMIT_EXCEEDED_MESSAGE = `You have already reached ${ISSUERS_LIMIT_PER_WATCHLIST} issuers. You can remove existing issuers to add new ones`;
export const USER_LIMIT_EXCEEDED_MESSAGE = `You have already reached ${ISSUERS_LIMIT_PER_USER} issuers across all of your watchlists. You can remove existing issuers to add new ones`;
export const BOTH_LIMITS_EXCEEDED_MESSAGE = `You have already reached ${ISSUERS_LIMIT_PER_WATCHLIST} issuers allowed in one watchlist and ${ISSUERS_LIMIT_PER_USER} across all of your watchlists. You can remove existing issuers to add new ones`;
export const WATCHLIST_LIMIT_EXCEEDED_MESSAGE_COMPANY_PAGE = `Limit of ${ISSUERS_LIMIT_PER_WATCHLIST} issuers reached for this watchlist.`;
export const USER_LIMIT_EXCEEDED_MESSAGE_COMPANY_PAGE = `Limit of ${ISSUERS_LIMIT_PER_USER} issuers reached across all watchlists.`;

export const getIsWatchlistLimitExceeded = (watchlist?: WatchList): boolean =>
  (watchlist?.tags.length ?? 0) >= ISSUERS_LIMIT_PER_WATCHLIST;

export const getIsUserLimitExceeded = (watchlists?: WatchList[]): boolean =>
  (watchlists?.map((watchlist) => watchlist.tags.length)?.reduce((acc, value) => acc + value, 0) ?? 0) >=
  ISSUERS_LIMIT_PER_USER;
